import React from "react";

function LoadingBox() {
  return (
    <div className="d-flex justify-content-center">
      <div className="spinner-border" role="status"></div>
    </div>
  );
}

export default LoadingBox;
